import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rdv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const resolvePhoto = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const token = localStorage.getItem("rdv_token");
  if (url.startsWith("/api/")) {
    return `${BACKEND_URL}${url}?auth=${encodeURIComponent(token || "")}`;
  }
  return url;
};
